import React, { FC, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { StepTemplate } from '../../components/styled/stepTemplate/StepTemplate'
import { Progress } from '../../@types/progress'
import { reportTrackingEvent } from '../../tracking/thunks'
import { useReportViewEvent } from '../../hooks'
import { RoomStepIcon } from '../../components/icons/StepIcons/RoomStepIcon'
import { RealEstateType } from '../../@types/realEstateType'
import { ReduxState } from '../../store/reducers'
import './RoomsStep.scss'
import RoomsStepper, { isValidRoomsNumber } from '../../components/RoomsStepper/RoomsStepper'

export interface RoomsStepProps {
  goToNextStep?: () => unknown
  goToPreviousStep?: () => unknown
  progress: Progress
  displayBack: boolean
}

export const getHeadline = (realEstateType?: RealEstateType): string => {
  switch (realEstateType) {
    case RealEstateType.HOUSE:
      return 'Wie viele Zimmer hat das Haus?'
    case RealEstateType.APARTMENT:
      return 'Wie viele Zimmer hat die Wohnung?'
    default:
      return 'Wie viele Zimmer hat die Immobilie?'
  }
}

export const RoomsStep: FC<RoomsStepProps> = (props) => {
  useReportViewEvent({ pageTitle: 'rooms' })
  const { realEstateType, rooms: numberOfRooms } = useSelector((state: ReduxState) => state.lead)
  const { theme } = useSelector((state: ReduxState) => state.config)
  const [inputType, setInputType] = useState<string>('default')

  const dispatch = useDispatch()

  const goToNextStep = () => {
    dispatch(
      reportTrackingEvent({
        pageTitle: 'rooms',
        label: `rooms_${inputType}`,
        inputValue: `${numberOfRooms}`,
        eventName: 'lead_input',
        customDimensions: {
          ga_cd_lead_engine_input_value: numberOfRooms,
        },
      })
    )
    if (props.goToNextStep) {
      props.goToNextStep()
    }
  }

  return (
    <StepTemplate
      headline={getHeadline(realEstateType)}
      icon={<RoomStepIcon />}
      isNextEnabled={isValidRoomsNumber(numberOfRooms)}
      goToNextStep={goToNextStep}
      goToPreviousStep={props.goToPreviousStep}
      dataTestingButton='rooms-next-button'
      progress={props.progress}
      displayBack={props.displayBack}
      backgroundColor={theme.background}
      textColor={theme.text}
    >
      <RoomsStepper onChange={() => setInputType('submit')} className={'rooms-container'} />
    </StepTemplate>
  )
}

export default RoomsStep
